import { FileX } from "lucide-react";
import GenericPracticePage from "@/components/GenericPracticePage";

const ExpunctionNondisclosure = () => {
  const mainContent = (
    <div className="prose prose-lg max-w-none">
      <h2 className="text-3xl font-bold mb-6">Clear Your Record and Protect Your Future</h2>
      <p className="text-xl text-muted-foreground mb-8">
        A criminal record can follow you for life—affecting your ability to get a job, rent an apartment, apply for loans, or even secure immigration benefits. But if you've been arrested or charged with a crime in Texas, you may be eligible for expunction or an order of nondisclosure.
      </p>

      <h3 className="text-2xl font-bold mb-4">Expunction (Record Sealing)</h3>
      <p className="mb-6">
        Expunction completely erases your arrest and court records. You can legally deny the arrest ever happened. Eligible cases include:
      </p>
      <ul className="list-disc pl-6 mb-6">
        <li>Arrests without charges filed</li>
        <li>Charges dismissed</li>
        <li>Acquittals (not guilty verdicts)</li>
        <li>Pardons</li>
        <li>Certain juvenile offenses</li>
      </ul>

      <h3 className="text-2xl font-bold mb-4">Nondisclosure (Record Sealing)</h3>
      <p className="mb-6">
        Orders of nondisclosure seal your criminal record from public view but remain visible to law enforcement and certain agencies. Available for:
      </p>
      <ul className="list-disc pl-6 mb-6">
        <li>Deferred adjudication probation completions</li>
        <li>Certain misdemeanor convictions</li>
        <li>Some pre-trial diversion programs</li>
      </ul>

      <h3 className="text-2xl font-bold mb-4">Benefits of Clearing Your Record</h3>
      <ul className="list-disc pl-6 mb-8">
        <li>Better employment opportunities</li>
        <li>Housing applications approval</li>
        <li>Professional license eligibility</li>
        <li>Educational opportunities</li>
        <li>Immigration relief (in some cases)</li>
      </ul>
    </div>
  );

  return (
    <GenericPracticePage
      title="Expunction & Nondisclosure"
      subtitle="Clear your criminal record and move forward with your life"
      icon={<FileX className="h-20 w-20 mx-auto mb-6 text-accent" />}
      mainContent={mainContent}
    />
  );
};

export default ExpunctionNondisclosure;
